module.exports = __webpack_public_path__ + "img/1.2901a22d.jpg";